import React from 'react';

const AuthBackIconSvg = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M11.75 15.5L6.25 10L11.75 4.5" stroke="white" stroke-width="1.3"/>
  </svg>
);

export default AuthBackIconSvg;